import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

import { ProjectStatus } from 'entities/project';

import { getDefaultProjectStatus, getProjectTabs } from '../../lib';
import { ProjectHeader } from '../ProjectHeader';
import { ProjectList } from '../ProjectList';

import styles from './ProjectTabs.module.scss';

const ProjectTabs = (): React.ReactElement => {
  const { t } = useTranslation('Project');
  const [page, setPage] = useState(1);

  const [activeKey, setActiveKey] = useState<ProjectStatus>(getDefaultProjectStatus());

  const onChangeStatus = (status: string) => {
    setPage(1);
    setActiveKey(status as ProjectStatus);

    setTimeout(() => {
      document.querySelector('main')?.scrollTo({ top: 0, behavior: 'smooth' });
    }, 0);
  };

  return (
    <div className={styles.tabs}>
      <div className={styles.headerWrapper}>
        <ProjectHeader />
        <Tabs activeKey={activeKey} onChange={onChangeStatus} tabBarGutter={4} items={getProjectTabs(t)} type="card" />
      </div>
      <ProjectList page={page} setPage={setPage} status={activeKey} />
    </div>
  );
};

export default ProjectTabs;
